const config = {
  routes: {
    label: 'Invitefriendfaq',
    prefix: '/invitefriendfaq',
  },
}

export default config
